// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oqkCW","top":"styles_top__8G_JV","left":"styles_left__1mAmA","description":"styles_description__12suv"};